import axios from "./axios";

/** GET /api/broker-gateway/client-health-data/ */
export const getClientHealthData = async () => {
  const response = await axios.get("/api/broker-gateway/client-health-data/");
  return response.data;
};
